import { MysqlTableDataset } from './../../dataset/mysql-table.dataset';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.mysql.copySourceType,
    tags: {
        datasetModel: Metamodel.modelFor(MysqlTableDataset)
    }
})
export class MysqlCopySource extends TabularCopySource {
}
